import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ContactMessageResponse } from "../contracts/ContactMessageResponse";
import { PaginatedContactMessageResult } from "../contracts/PaginatedContactMessageResult";

export const fetchContactMessages = createAsyncThunk<
  PaginatedContactMessageResult,
  { page?: number; pageSize?: number },
  { rejectValue: ApiErrorResponse }
>("contactMessages/fetch", async ({ page = 1, pageSize = 20 }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<PaginatedContactMessageResult>("/contact-messages", {
      params: { page, pageSize },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

export const markContactMessageRead = createAsyncThunk<
  ContactMessageResponse,
  string,
  { rejectValue: ApiErrorResponse }
>("contactMessages/markRead", async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post<ContactMessageResponse>(`/contact-messages/${id}/read`);
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

export const deleteContactMessage = createAsyncThunk<string, string, { rejectValue: ApiErrorResponse }>(
  "contactMessages/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/contact-messages/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(toApiError(error));
    }
  },
);
